import { useEffect } from 'react';

export function useRevealObserver() {
  useEffect(() => {
    const tryEnable = () => {
      const probe = document.createElement("div");
      probe.style.cssText = "position:fixed;left:-9999px;opacity:0;transition:opacity 50ms";
      document.body.appendChild(probe);
      probe.getBoundingClientRect();
      probe.style.opacity = "1";
      
      setTimeout(() => {
        const cs = getComputedStyle(probe).opacity;
        document.body.removeChild(probe);
        if (parseFloat(cs) > 0.5) {
          document.documentElement.classList.add("reveal-ready");
          startObserving();
        }
      }, 120);
    };

    const startObserving = () => {
      const els = document.querySelectorAll("[data-reveal]:not(.in)");
      if (els.length === 0) return;

      els.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add("in");
      });

      if (!("IntersectionObserver" in window)) {
        els.forEach(el => el.classList.add("in"));
        return;
      }
      
      let io;
      try {
        io = new IntersectionObserver((entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
        document.querySelectorAll("[data-reveal]:not(.in)").forEach(el => io.observe(el));
      } catch (err) {
        document.querySelectorAll("[data-reveal]:not(.in)").forEach(el => el.classList.add("in"));
      }

      setTimeout(() => {
        document.querySelectorAll("[data-reveal]:not(.in)").forEach(el => el.classList.add("in"));
        document.querySelectorAll("[data-reveal]").forEach(el => {
          if (el.getAnimations) {
            try { el.getAnimations().forEach(a => a.finish()); } catch (_) {}
          }
        });
      }, 1500);
    };

    tryEnable();
  }, []);
}
